export enum ErrorTypeE {
  INTERNAL_ERROR = 'internal_error',
}

export type ErrorT = {
  status: string | ErrorTypeE
  message?: string
  error?: { message: string; params: Record<string, string>; path: string }[]
}
